import { getAll } from '../../api';

const state = {
  areas: [],
};

const getters = {
  getAreas(state) {
    return state.areas;
  },
};

const actions = {
  acquireAreas: async ({ commit, rootGetters }) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/area?query=${
        encodeURIComponent(
          `{get(type_name: "area", 
            table_name:"${clientTable}", 
            index: "all-index"
          ){
            uuid,
            area_name
            error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        commit('setAreas', res.data.data.get);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  }),
};

const mutations = {
  setAreas(state, payload) {
    if (payload) {
      for (let i = 0; i < payload.length; i++) {
        if (
          !state.areas.find((area) => area.value === payload[i].uuid)
        ) {
          state.areas.push({
            text: payload[i].area_name,
            value: payload[i].uuid,
          });
        }
      }
    } else {
      state.areas = [];
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
